import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams, Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { createDepartmentAction, updateDepartmentAction } from "../../../store/actions/DepartmentAction";
import { showErrorAlert } from "../../../services/ErrorHandlingService";
import { getBranchesAction } from "../../../store/actions/BranchAction";
import Loader from "../Common/Loader";

const AddDepartment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const department = location.state?.department || null;
  const returnTo = location.state?.returnTo || null;

  //const isEditMode = !!department;

  const [form, setForm] = useState({
    department_name: "",
    department_description: "",
    department_status: "Active",
    branches: ""
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [selectedBranches, setSelectedBranches] = useState([]);

  const branchList = useSelector((state) => state.branches.branches);
  // adjust if your reducer is named differently

  useEffect(() => {
    dispatch(getBranchesAction(false));
  }, [dispatch]);

  const branchOptions = branchList.map(branch => ({
    value: branch.branch_id,
    label: branch.branch_name
  }));

  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];

  // Initialize form in edit mode
  useEffect(() => {
    if (department && branchList.length > 0) {
      setFetching(true);
      setErrors({});
      const selectedIds = department.branches?.map(branch => String(branch.branch_id)) || [];

      const branchesToSelect = branchList
        .filter(branch => selectedIds.includes(String(branch.branch_id)))
        .map(branch => ({
          value: branch.branch_id,
          label: branch.branch_name
        }));

      setSelectedBranches(branchesToSelect);
      setForm({
        department_name: department.department_name || "",
        department_description: department.department_description || "",
        department_status: department.department_status || "",
        branches: selectedIds
      });
      setFetching(false);
    }
  }, [department, branchList]);



  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  
    // remove error instantly
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  

  const handleStatusChange = (selectedOption) => {
    setForm((prev) => ({
      ...prev,
      department_status: selectedOption ? selectedOption.value : "",
    }));
  
    setErrors((prev) => ({
      ...prev,
      department_status: "",
    }));
  };
  
  const handleBranchChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
  
    setSelectedBranches(selectedOptions);
  
    setForm((prev) => ({
      ...prev,
      branches: selectedValues,
    }));
  
    setErrors((prev) => ({
      ...prev,
      branches: "",
    }));
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    // Validate required fields
    const newErrors = {};
    if (!form.department_name.trim()) newErrors.department_name = "Department Name is required";
    if (!form.branches || form.branches.length === 0) {
      newErrors.branches = "Select at least one branch name";
    }

    if (!form.department_status) newErrors.department_status = "Status is required";
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      //showErrorAlert("Please fill in all required fields!");
      setLoading(false);
      return;
    }
    const payload = {
      ...form,
      branches: Array.isArray(form.branches) ? form.branches.join("|") : form.branches
    };

    try {
      if (id) {
        await dispatch(updateDepartmentAction(payload, id, navigate));
      } else {
        await dispatch(createDepartmentAction(payload, navigate));
      }
    } catch (error) {
      console.error("Form submission failed:", error);
      showErrorAlert(id ? "Failed to update department" : "Failed to add department");
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <Loader size="lg" />
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="d-flex justify-content-end p-3">
          <Link to="/departments">
            <Button variant="primary">Back</Button>
          </Link>
        </div>
        <div className="card">
          <div className="card-body">
            {/* <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px" }}>
              <button onClick={() => navigate("/department")} className="btn btn-primary">
                Back
              </button>
            </div> */}
            <h4 className="mb-4">{id ? "" : ""}</h4>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Department Name</label>
                  <span style={{ color: "red" }}>*</span>
                  <input
                    type="text"
                    className="form-control"
                    name="department_name"
                    placeholder="Enter Department Name"
                    value={form.department_name}
                    onChange={handleChange}
                  //required
                  />
                  
                  {errors.department_name && <small className="text-danger">{errors.department_name}</small>}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Branch</label>
                  <span style={{ color: "red" }}>*</span>
                  <Select
                    isMulti
                    options={branchOptions}
                    value={selectedBranches}
                    onChange={handleBranchChange}
                    placeholder="Select Branch(es)"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        backgroundColor: "#e0e0e0",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "4px",
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                    }}
                  />
                  {errors.branches && (
                    <div className="text-danger d-block mb-2">{errors.branches}</div>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Status</label>
                  <span style={{ color: "red" }}>*</span>
                  <Select
                    options={statusOptions}
                    value={statusOptions.find(opt => opt.value === form.department_status)}
                    onChange={handleStatusChange}
                    placeholder="Select Status"
                    className={errors.department_status ? "is-invalid" : ""}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "4px",
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                    }}
                    isClearable
                  />
                  {errors.department_status && (
                    <div className="invalid-feedback d-block">{errors.department_status}</div>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-xl-12 mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    name="department_description"
                    placeholder="Enter the Description"
                    value={form.department_description}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-primary me-2"
                disabled={loading || fetching}
              >
                {loading ? (
                  <>
                    <Loader size="sm" />
                    <span className="ms-2">Submitting...</span>
                  </>
                ) : (
                  id ? "Update Department" : "Add Department"
                )}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate("/departments")}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDepartment;